import { lazy } from "react";

export const AdminPage = lazy(() => import("./AdminPage"));
export const AdminReportPage = lazy(() => import("./AdminReportPage"));
export const AdminUsersPage = lazy(() => import("./AdminUsersPage"));
export const AdminCategoryPage = lazy(() => import("./AdminCategoryPage"));
export const AdminFilterPage = lazy(() => import("./AdminFilterPage"));
export const AdminItemPage = lazy(() => import("./AdminItemPage"));
